/* Fancybox */
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { fr_FR } from '@fancyapps/ui/dist/fancybox/l10n/fr_FR.js';

/* Masonry */
import masonry from 'masonry-layout';

/* Isotope */
import isotope from 'isotope-layout';

import './style.scss';

document.addEventListener("DOMContentLoaded", () => {
    Fancybox.bind('[data-fancybox]', {
        l10n: fr_FR
    });
});
